<div *ngIf="visible" class="red-point"></div>
